import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions';
import mutations from './mutations'
import getters from './getters'

Vue.use(Vuex);

const state = {
  polls: [],
  profile: {},
  currentPoll: {},
  pollComponent: null,
  isFetchedCompanyPolls: false,
  unvalidPolls: []
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
